import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "../extract";

export function useOrganization() {
  return useQuery({
    queryKey: ["organization"],
    queryFn: () => {
      return extractionWrapper(api.organization.getMyOrganization());
    },
  });
}
